'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { noEmptySearchClient } from 'components/essentials/AlgoliaSearchClient';
import CatchAlgoliaSearchError from 'components/essentials/CatchAlgoliaSearchError';
import { InstantSearch, Configure, Index } from 'react-instantsearch';
import { ALGOLIA_HAS_LISTABLE_STOCK_FILTER, ALGOLIA_INDEX_NAME, DEFAULT_SEARCH_MODAL_NUMERIC_FILTERS } from 'commons/constants';
import useOpenSearch from 'global-state/isSearchOpen/useOpenSearch';
import useIsSearchOpen from 'global-state/isSearchOpen/useIsSearchOpen';
import useCloseSearch from 'global-state/isSearchOpen/useCloseSearch';
import useAdvancedSearchURL from '../advanced-search-next/hooks/useAdvancedSearchURL';
import useIsAdvancedSearch from '../hooks/useIsAdvancedSearch';
import JBSearchBoxNext from './components/JBSearchBoxNext';
import SearchResultsWrapperNext from './components/SearchResultsWrapperNext';
import SearchModalProductGridNext from './components/SearchModalProductGridNext';
import SeeFullResultsButtonNext from './components/SeeFullResultsButtonNext';
import CategoryHitsNext from './components/CategoryHitsNext';
import QuickLinkDialog from './components/QuickLinkDialog';
import ResultsByCategoryNext from './components/ResultsByCategoryNext';
import IndexHitsCount from './components/ResultsByCategoryNext/components/IndexHitsCount';
import ClearModalSearchQueryWhenClosed from './components/ClearModalSearchQueryWhenClosed';

/**
 * Consumer Search Bar - Next version (for new Consumer app)
 * Uses React InstantSearch v7
 */
const ConsumerSearchBarNext = () => {
  const $ = _c(31);
  const [isSearchBarActivated, setisSearchBarActivated] = useState(false);
  const prevPathnameRef = useRef(null);
  const closeSearch = useCloseSearch();
  const openSearch = useOpenSearch();
  const isSearchOpen = useIsSearchOpen();
  const isAdvancedSearch = useIsAdvancedSearch();
  const {
    pathname
  } = useAdvancedSearchURL();
  let t0;
  let t1;
  if ($[0] !== closeSearch || $[1] !== pathname) {
    t0 = () => {
      if (prevPathnameRef.current !== null && prevPathnameRef.current !== pathname) {
        closeSearch();
        setisSearchBarActivated(false);
      }
      prevPathnameRef.current = pathname;
    };
    t1 = [pathname, closeSearch];
    $[0] = closeSearch;
    $[1] = pathname;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  let t2;
  if ($[4] !== closeSearch) {
    t2 = e => {
      if (e.key === "Enter" || e.key === " ") {
        closeSearch();
      }
    };
    $[4] = closeSearch;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleOverlayKeyDown = t2;
  let t3;
  if ($[6] !== openSearch) {
    t3 = () => {
      setisSearchBarActivated(true);
      openSearch();
    };
    $[6] = openSearch;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleSearchBarFocus = t3;
  if (isAdvancedSearch) {
    return null;
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = ["*"];
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  let t6;
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Configure hitsPerPage={3} facets={t4} filters={ALGOLIA_HAS_LISTABLE_STOCK_FILTER} numericFilters={DEFAULT_SEARCH_MODAL_NUMERIC_FILTERS} attributesToRetrieve={["_highlightResult", "product_id", "name"]} />;
    t6 = <CatchAlgoliaSearchError />;
    t7 = <ClearModalSearchQueryWhenClosed />;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
  }
  let t8;
  if ($[12] !== closeSearch || $[13] !== handleSearchBarFocus) {
    t8 = <JBSearchBoxNext isActive={true} setInactive={_temp} toggleSearchOpen={closeSearch} variant="ConsumerInstantSearch" handleSearchBarFocus={handleSearchBarFocus} />;
    $[12] = closeSearch;
    $[13] = handleSearchBarFocus;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== closeSearch || $[16] !== isSearchOpen) {
    t9 = isSearchOpen && <SearchResultsWrapperNext><QuickLinkDialog toggleSearchOpen={closeSearch}><div className="bg-white absolute w-full" data-xc="search-dropdown-preview"><div className="flex w-full max-w-none mx-auto px-2 gap-6"><div className="flex-1"><div className="bg-gray-50 p-6 rounded-lg" data-xc="search-dropdown-products"><SearchModalProductGridNext /><div className="mt-6 flex justify-center"><SeeFullResultsButtonNext /></div></div></div><div className="w-64"><div className="bg-gray-50 p-0 rounded-lg h-full" data-xc="search-dropdown-categories"><Index indexName="categories"><Configure hitsPerPage={5} filters="" numericFilters={["fk_store_id=1"]} facetFilters={["is_searchable:1"]} attributesToRetrieve={["objectID", "category_name", "category_sef_url", "url"]} /><CategoryHitsNext toggleSearchOpen={closeSearch} /></Index></div></div><div className="w-64"><div className="bg-gray-50 p-6 rounded-lg h-full" data-xc="search-dropdown-results-by"><ResultsByCategoryNext toggleSearchOpen={closeSearch} /><Index indexName="reviews"><Configure facets={["*"]} filters="" numericFilters="" facetFilters="" /><IndexHitsCount indexName="reviews" toggleSearchOpen={closeSearch} /></Index><Index indexName="customer_photos"><Configure facets={["*"]} filters="" numericFilters="" /><IndexHitsCount indexName="customer_photos" toggleSearchOpen={closeSearch} /></Index><Index indexName={ALGOLIA_INDEX_NAME.STATIC_PAGES}><Configure filters="" numericFilters={["is_active=1", "show_in_search=1"]} /><IndexHitsCount indexName={ALGOLIA_INDEX_NAME.STATIC_PAGES} toggleSearchOpen={closeSearch} /></Index></div></div></div></div></QuickLinkDialog></SearchResultsWrapperNext>;
    $[15] = closeSearch;
    $[16] = isSearchOpen;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t8 || $[19] !== t9) {
    t10 = <div className="bg-white relative max-[1023px]:z-10 lg:!z-[1002]"><InstantSearch searchClient={noEmptySearchClient} indexName={ALGOLIA_INDEX_NAME.PRODUCTS}>{t5}{t6}{t7}{t8}{t9}</InstantSearch></div>;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  const t11 = !isSearchOpen || !isSearchBarActivated;
  const t12 = isSearchOpen && isSearchBarActivated;
  let t13;
  if ($[21] !== t11 || $[22] !== t12) {
    t13 = classNames("fixed inset-0 bg-blackOverlay z-[1001] transition-opacity duration-300 ease-out", {
      hidden: t11,
      block: t12
    });
    $[21] = t11;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== closeSearch || $[25] !== handleOverlayKeyDown || $[26] !== t13) {
    t14 = <div className={t13} onClick={closeSearch} role="button" tabIndex={0} onKeyDown={handleOverlayKeyDown} aria-label="Close search modal" />;
    $[24] = closeSearch;
    $[25] = handleOverlayKeyDown;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t10 || $[29] !== t14) {
    t15 = <div className="bg-white max-[1023px]:relative max-[1023px]:z-10">{t10}{t14}</div>;
    $[28] = t10;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  return t15;
};
export default ConsumerSearchBarNext;
function _temp() {}